import React from 'react';
import { Checkbox } from 'antd';
import DebouncedInput from './DebouncedInput';

/**
 * Other Option Component - Allows enabling "Other" option for questions
 */
export const OtherOption = ({ question, pageIndex, sectionIndex, questionIndex, updateQuestionField }) => (
  <div>
    <Checkbox
      checked={question.questionOptions?.allowOther || false}
      onChange={(e) => {
        updateQuestionField(pageIndex, sectionIndex, questionIndex, (q) => {
          if (!q.questionOptions) q.questionOptions = {};
          q.questionOptions.allowOther = e.target.checked;
          if (e.target.checked) q.questionOptions.otherLabel = q.questionOptions.otherLabel || 'Other';
        });
      }}
    >
      Enable "Other" option
    </Checkbox>
    {question.questionOptions?.allowOther && (
      <DebouncedInput
        placeholder="Other label"
        value={question.questionOptions?.otherLabel || 'Other'}
        onChange={(e) => {
          updateQuestionField(pageIndex, sectionIndex, questionIndex, (q) => {
            if (!q.questionOptions) q.questionOptions = {};
            q.questionOptions.otherLabel = e.target.value;
          });
        }}
        style={{ marginTop: 8 }}
        size="small"
      />
    )}
  </div>
);





